// Bounded retries for transient Storage gateway faults (e.g. Cloudflare 520).
// The object key remains unchanged; verify if an upload committed before re-sending.
const RETRY_STATUS = new Set([408, 429, 500, 502, 503, 504, 520, 522, 524]);
export function transientStorageError(error) {
  if (!error) return false;
  const status = Number(error.statusCode || error.status || error.originalError?.status);
  if (RETRY_STATUS.has(status)) return true;
  const message = String(error.message || error.originalError?.message || '');
  return /\b(408|429|500|502|503|504|520|522|524)\b|failed to fetch|network.?error|timeout|connection reset/i.test(message);
}

function asStorageError(error){
  if(error instanceof Error)return error;
  return Object.assign(new Error(String(error?.message||'Falha ao enviar imagem.')),
    {statusCode:error?.statusCode||error?.status});
}
export async function uploadWithRecovery(bucket, path, file, options, {sleep = ms => new Promise(resolve=>setTimeout(resolve,ms)), attempts=3} = {}) {
  const folder = path.slice(0,path.lastIndexOf('/'));
  const filename = path.slice(path.lastIndexOf('/')+1);
  async function exists() {
    try {
      const result = await bucket.list(folder, {search:filename,limit:20});
      return !result.error && Array.isArray(result.data) && result.data.some(item => item.name===filename);
    } catch { return false; }
  }
  for(let attempt=0;attempt<attempts;attempt++){
    let error;
    try {
      const result = await bucket.upload(path,file,{...options,upsert:false});
      if (!result.error) return {path,recovered:false};
      error=result.error;
    } catch(e){error=e;}
    const conflict = Number(error?.statusCode||error?.status)===409 ||
      /already exists|duplicate/i.test(String(error?.message||''));
    if(!transientStorageError(error) && !conflict)throw asStorageError(error);
    // Gateway 520 might hide a successful write. Never create a second object.
    if(await exists())return {path,recovered:true};
    if(conflict)throw asStorageError(error);
    if(attempt===attempts-1)throw asStorageError(error);
    await sleep(Math.min(2000,350*(attempt+1)*(attempt+1)));
  }
  throw new Error('storage_retry_exhausted');
}
export function readableUploadError(error){
  return transientStorageError(error)
    ? 'O serviço de imagens respondeu com uma falha temporária (520). Tente Salvar novamente; os campos e as fotos continuam no formulário.'
    : String(error?.message||error||'Falha ao enviar imagem.');
}
